import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSectionSchemasQuery = createQueryHook(
  ShopRendererDraftApiClient.getSectionSchemas,
  {
    queryKey: ['sectionSchemas'],
  },
)
